<!-- <template>
  <div v-if="visible" class="full-screen-loader">
    <div class="loader-backdrop"></div>

    <div class="loader-card">
      <div class="loader-spinner"></div>

      <div class="loader-texts">
        <p class="loader-title">{{ text }}</p>
        <p class="loader-subtitle">Por favor, espera un momento…</p>
      </div>
    </div>
  </div>
</template> -->

<template>
  <div v-if="visible" class="full-screen-loader">
    <div class="loader-backdrop"></div>

    <div class="loader-card">
      <img :src="logo" alt="Cargando" class="loader-logo" />

      <div class="loader-texts">
        <p class="loader-title">{{ text }}</p>
        <p class="loader-subtitle">Por favor, espera un momento…</p>
      </div>
    </div>
  </div>
</template>


<script>
import logo from '@/assets/logo.png';

export default {
  name: 'LoadingOverlay',
  data() {
    return {
      visible: false,
      text: 'Cargando...',
      logo,
    };
  },
  methods: {
    show(customText) {
      if (customText) {
        this.text = customText;
      }
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>


<style scoped>
.full-screen-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.loader-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  /* un blur suave en blanco */
  backdrop-filter: blur(4px);
}

/* Tarjeta central estilo Myfrac */
.loader-card {
  position: relative;
  z-index: 1;
  min-width: 260px;
  max-width: 90vw;
  padding: 1.5rem 1.75rem;
  border-radius: 1rem;
  background: #ffffff;
  /* fondo blanco */
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.10),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #1e3a8a;
  /* azul oscuro */
}

/* Logo girando */
.loader-logo {
  width: 2.75rem;
  height: 2.75rem;
  animation: loader-spin 2.2s linear infinite;
  /* más lento */
  object-fit: contain;
  opacity: 0.95;
}

/* Textos */
.loader-texts {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.loader-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e3a8a;
  /* azul oscuro */
}

.loader-subtitle {
  font-size: 0.85rem;
  color: #4b5563;
  /* gris limpio */
}

/* Animación */
@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
